module.exports = __webpack_public_path__ + "static/media/Perpendicular edges.be7f4b87.svg";